import { QuestionResolutionError } from '@/errors/questionResolution';
import { Feedback, FeedbackCreateDTO } from '@/models/Feedback';
import { hashMap } from '@/utils/shared/hashMap';
import { remapIdsByPosition } from './remapIdsByPosition';

type WithId = { id?: number };

export const toClonedChildren = <T extends WithId>(
  items: T[],
  sourceItems: WithId[],
  targetItems: WithId[],
): T[] => {
  if (sourceItems === targetItems) return items;
  const remapped = remapIdsByPosition(items, sourceItems, targetItems);
  if (remapped.some((item, index) => items[index].id && !item.id))
    throw new QuestionResolutionError();
  return remapped;
};

export const toClonedFeedbacks = (
  feedbacks: FeedbackCreateDTO[],
  sourceFeedbacks: Pick<Feedback, 'id' | 'type'>[],
  targetFeedbacks: Pick<Feedback, 'id' | 'type'>[],
): FeedbackCreateDTO[] => {
  if (sourceFeedbacks === targetFeedbacks) return feedbacks;
  const sourceById = hashMap(sourceFeedbacks, ({ id }) => id);
  const targetByType = hashMap(targetFeedbacks, ({ type }) => type);
  return feedbacks.map(feedback => {
    if (!feedback.id) return feedback;
    const source = sourceById.get(feedback.id);
    const target = source && targetByType.get(source.type);
    if (!target) throw new QuestionResolutionError();
    return { ...feedback, id: target.id };
  });
};
